String.prototype.endsWith||(String.prototype.endsWith=function(t,n){return n<this.length?n|=0:n=this.length,this.substr(n-t.length,t.length)===t});



//////////////////
// WEBPACK FOOTER
// ./~/mdn-polyfills/String.prototype.endsWith.js
// module id = 491
// module chunks = 0